import React, { Component } from "react";

import orderBy from 'lodash/orderBy'
import { connect } from "react-redux";
import * as actions from "./../../actions";

import PropTypes from 'prop-types';


import { withStyles} from '@material-ui/core/styles';

import ProductCard from './../reusableComponents/ProductCard'

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Collapse from '@material-ui/core/Collapse';
import ArrowUpIcon from 'mdi-material-ui/ChevronUp';
import ArrowDownIcon from 'mdi-material-ui/ChevronDown';
import Grow from '@material-ui/core/Grow';

const styles = theme => ({
  root:{
    position: "relative",
    overflow: "hidden",
    minHeight: 450,


    startTransition: false,

    paddingTop: theme.spacing.unit * 2,
  },
  overlay:{
    position: "absolute",
    top: 0,
    left: 0,

    width: "100%",
    height: "100%",
    background: theme.palette.background.white,


  },

  cardSlider:{
    display: "flex",
    marginTop: 20
  },


  hidePackages:{

    display: "none",

  },
  showPackages:{

  }
})

class ProductsPage extends Component{

  state = {
    showPackages: false,
    timeoutFunction: null
  }

  componentDidMount(){
    this.setState({timeoutFunction: setTimeout(()=>this.setState({startTransition: true}),500)})
  }

  componentWillUnmount(){
    clearTimeout(this.state.timeoutFunction)
  }

  togglePackages = ()=>{
    this.setState({showPackages: !this.state.showPackages})
  }

  static contextTypes = {
    router: PropTypes.object
  }



  render(){
    const {classes, productsData, packageStatisticData} = this.props
    //console.log(packageStatisticData)
    if(productsData !== "loading" && packageStatisticData !== "loading"){
      // create arry of products and add key to product.id to keep its indentifier
      let products = Object.keys(productsData).map((key, i)=>{
        let product = productsData[key]
        product.id = key
        return product
      })
      
      products = orderBy(products, 'settings.landingPagePosition')

      return (
        <div className={classes.root}>
          <span className={classes.overlay}></span>
          <Grid container  justify="center">
            <Grid item xs={12} sm={12} >
                <Grid container justify="space-around">
                  {products.map((product, i)=>{
                      if(product.settings.discountActive){
                        return (

                            <Grow
                              in={this.state.startTransition}
                              style={{ transformOrigin: '0 0 0' }}
                              timeout={700*(i+1)}
                              key={i}
                            >


                            <Grid  item xs={12} sm={6} md={2} >
                              {
                                packageStatisticData.packages && (
                                  <ProductCard  discount product={product} statistic={packageStatisticData.packages[product.id]}/>
                                )
                              }
                            </Grid>
                          </Grow>


                          )
                      }else return null
                  })}
                  {products.map((product, i)=>{
                      if(i < 4  && product.settings.subscriptionSpanDiscount !== 1 ){
                        return (

                            <Grow
                              in={this.state.startTransition}
                              style={{ transformOrigin: '0 0 0' }}
                              timeout={700*(i+1)}
                              key={i}
                            >


                            <Grid  item xs={12} sm={6} md={2} >
                              {
                                packageStatisticData.packages && (
                                  <ProductCard  product={product} statistic={packageStatisticData.packages[product.id]}/>
                                )
                              }
                            </Grid>
                          </Grow>


                          )
                      }else return null
                  })}
                </Grid>
            </Grid>

            <Grid item xs={12}  sm={12}>

                <Collapse in={this.state.showPackages}>
                  <Grid container >
                    { packageStatisticData.packages && products.map((product, i) => {
                        if(i >= 4){
                          return (
                            <Grow
                              in={this.state.showPackages}
                              style={{ transformOrigin: '0 0 0' }}
                              key={i}
                              timeout={700*(i+1)}
                            >
                              <Grid  item xs={12} sm={6} md={3}>
                                <ProductCard  product={product} statistic={packageStatisticData.packages ? packageStatisticData.packages[product.id] : {}}/>
                              </Grid>
                            </Grow>
                          )
                        }return null
                    })}
                  </Grid>
                </Collapse>

                <div style={{display: "flex", justifyContent: "center"}}>


                    {
                      Object.keys(products).length > 4 && this.state.showPackages && (
                        <Button onClick={this.togglePackages} style={{fontSize: 30}} >
                          Zapri
                          <ArrowUpIcon style={{fontSize: 50}} />
                        </Button>
                      )
                    }


                    {
                      Object.keys(products).length > 4 && !this.state.showPackages && (
                        <Button onClick={this.togglePackages} style={{fontSize: 30}} >
                          Vsi paketi
                          <ArrowDownIcon style={{fontSize: 50}} />
                        </Button>
                      )
                    }



                </div>
            </Grid>


          </Grid>
        </div>
      )
    }else{
      return (
        <div className={classes.root}>
          <span className={classes.overlay}></span>
        </div>
      )
    }

  }
}

ProductsPage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({ productsData, packageStatisticData }) => {
  return {
    productsData,
    packageStatisticData,
  };
};

export default connect(mapStateToProps, actions)( withStyles(styles, { withTheme: true })(ProductsPage))



// WEBPACK FOOTER //
// ./src/components/main/ProductsPage.js